import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  NoDataFound,
} from "../../../../../components/table/tableComponent";
import DefaultButton from "../../../../../components/buttons/defaultButton";
import DefaultCheckbox from "../../../../../components/inputs/defaultCheckbox";
import DefaultBadge from "../../../../../components/badge/defaultBadge";
import BottomDrawer from "../../../../common/drawer/bottomDrawer";
import DefaultInvoice from "../../../../common/invoice/defaultInvoice";
import BasicDetails from "../../../../common/invoice/components/basicDetails";
import InvoiceTable from "../components/invoiceTable";
import SubTotal from "../../../../common/invoice/components/subTotal";
import TableSkeleton from "../../../../../components/skeleton/tableSkeleton";
import toast from "react-hot-toast";
import CommonModal from "../../../../../components/modals/commonModel";
import AddCashForm from "../../../../../components/forms/feeSetup/addCashForm";
import PaySalaryForm from "../../salaryReport/innerScreens/paySalaryForm";

const EndOfServiceTable = ({
  tableData,
  loading,
  handleTerminate,
  setIsOpenSheet,
  isOpenSheet,
  isTerminate,
}) => {
  const [selected, setSelected] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    if (!selectedId) {
      toast.error("Please select at least one item for payment.");
      return;
    }

    setIsModalOpen(!isModalOpen);
  };

  const TableHeaderData = [
    "Employee Name",
    "Date of Joining",
    "Department",
    "Job Title",
    "Experience",
    "Salary",
    "Pending Salary",
    "Action",
  ];

 

  const opoeBottomDrawer = (item) => {
    
      const newData = {
        data: [
          { label: "Employee Name", value: item.name },
          { label: "Date Of Joining", value: item.date_of_join },
          { label: "Department", value: item.designation?.department?.name || "-" },
          { label: "Job Title", value: item.designation?.name || "-" },
        ],
      invoiceTableHeading: ["Employee Name", "Description", "Pending Salary"],

      invoicedata: [
        {
          name: item?.name,
          pending_salary: item?.pending_salary ? item?.pending_salary : "0",
          description: item?.description,
        },
      ],
      subTotal: {
        items_amount: parseFloat(
          item?.pending_salary ? item?.pending_salary : "0"
        ),
        tax_percent: parseFloat("0"),
        hideTex: true,
      },
    };

    setSelected(newData);
    setSelectedId(item);
    setIsOpenSheet(true);
  };

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            {TableHeaderData.map((header, i) => (
              <TableHead key={i}>{header}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {loading ? (
            <TableSkeleton colSpan={TableHeaderData.length} />
          ) : (
            <Fragment>
              {tableData?.length ? (
                tableData
                  // .filter((s) => s.pending_salary > 0)
                  .map((item, i) => {
                    return (
                      <TableRow key={i}>
                        <TableCell>{item?.name}</TableCell>
                        <TableCell>{item?.date_of_join}</TableCell>
                        <TableCell>
                          {item?.designation?.department?.name}
                        </TableCell>
                        <TableCell>{item?.designation?.name}</TableCell>
                        <TableCell>{item?.total_experience} year's</TableCell>
                        <TableCell>
                          {item?.salary?.net_salary
                            ? item?.salary?.net_salary
                            : 0}
                        </TableCell>
                        <TableCell>{item?.pending_salary}</TableCell>
                        <TableCell className="flex items-center gap-2">
                          {item?.user.status === 0 ? (
                            <span className="text-error-800">Terminated</span>
                          ) : (
                            <DefaultButton
                              name="Terminate"
                              onClick={() => {
                                opoeBottomDrawer(item);
                              }}
                            />
                          )}
                        </TableCell>{" "}
                      </TableRow>
                    );
                  })
              ) : (
                <NoDataFound colSpan={TableHeaderData.length} />
              )}
            </Fragment>
          )}
        </TableBody>
      </Table>

      <BottomDrawer
        isOpen={isOpenSheet}
        setIsOpen={setIsOpenSheet}
        title="Pay Balance"
        size="md"
      >
        {selected ? (
          <DefaultInvoice>
            <BasicDetails data={selected.data} />
            <div className="flex flex-col gap-2 text-theme font-bold">
              Balance Payment
              <InvoiceTable
                TableHeaderData={selected.invoiceTableHeading}
                tableData={selected.invoicedata}
              />
            </div>
            <SubTotal data={selected.subTotal} />
            {selected.subTotal.items_amount !== 0 ? (
              <div className="flex items-center gap-2 text-theme font-bold">
                Please Pay Balance Amount-
                <DefaultButton name="Online Payment" onClick={toggleModal} />
                <DefaultButton name="Bank Transaction" onClick={toggleModal} />
                <DefaultButton name="Cash" onClick={toggleModal} />
              </div>
            ) : (
              <div className="flex items-center gap-2 text-theme font-bold">
                Please Pay Balance Amount-
                <DefaultButton
                  name="Terminate"
                  loading={isTerminate}
                  onClick={() => {
                    handleTerminate(selectedId);
                  }}
                />
              </div>
            )}
          </DefaultInvoice>
        ) : (
          ""
        )}
      </BottomDrawer>
      {isModalOpen && (
        <CommonModal
          modalSize="lg"
          headerTitle={"Cash Detail"}
          onClose={() => {
            // setSelected(null);
            setIsModalOpen(false);
          }}
          onSave={() => {

          }}
          show={isModalOpen}
        >
          {/* <AddCashForm
            // handleRefresh={handleRefresh}
            isModal={true}
            // data={data}
            setSelected={setSelected}
            selected={selectedId}
            onClose={() => {
              // setSelected(null);
              setIsModalOpen(false);
            }}
            id={selected ? selected : ""}
          /> */}
          <PaySalaryForm
        
            isModal={true}
            // data={}
            handleRefresh={toggleModal}
            // setSelected={setSelectedData}
            selected={selectedId}
            isTerminate={true}
            onClose={() => {
              // setSelected(null);
              setIsModalOpen(false);
            }}
          />
        </CommonModal>
      )}
    </div>
  );
};

// EndOfServiceTable.propTypes = {
//   tableData: PropTypes.array.isRequired,
//   loading: PropTypes.bool.isRequired,
// };

export default EndOfServiceTable;
